import { Component, OnInit, Input, LOCALE_ID, Inject, OnChanges } from '@angular/core';
import { AccountService } from '../../shared/account.service';
import { Account } from '../../shared/account.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { User } from '../../../user/shared/user.model';
import { Category } from '../../../category/shared/category.model';
import { RecentSupplier } from '../../../recent-supplier/shared/recent-supplier.model';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatInput } from '@angular/material/input';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { formatDate } from '@angular/common';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import { default as _rollupMoment } from 'moment';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY/MM/DD',
  },
  display: {
    dateInput: 'YYYY/MM/DD',
    monthYearLabel: 'YYYY年M月',
    dateA11yLabel: 'YYYY/MM/DD',
    monthYearA11yLabel: 'YYYY年M月',
  },
};

@Component({
  selector: 'app-account-detail-form',
  templateUrl: './account-detail-form.component.html',
  styleUrls: ['./account-detail-form.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class AccountDetailFormComponent implements OnChanges, OnInit {

  maxDate = new Date();

  constructor(
    @Inject(LOCALE_ID) private _locale: string,
    private _formBuilder: FormBuilder,
    private _accountService: AccountService,
  ) { }

  @Input() account: Account = new Account();
  @Input() readonly = true;

  public formGroup?: FormGroup;

  me?: User;
  users?: User[];
  categories?: Category[];
  suppliers?: RecentSupplier[];
  filteredSuppliers$?: Observable<RecentSupplier[]>;

  archived = false;

  compareFn(option1: any, option2: any) {
    return option1 && option2 ? option1.id === option2.id : option1 === option2;
  }

  ngOnChanges() {
    if (this.account) {
      this.formGroup = this._formBuilder.group({
        amount: [{ value: this.account.amount, disabled: this.readonly }, Validators.required],
        paidOn: [{
          value: this.account.paidOn ? formatDate(this.account.paidOn, 'y-MM-dd', this._locale) : '',
          disabled: this.readonly
        }, Validators.required],
        category: [{ value: this.account.category, disabled: this.readonly }, Validators.required],
        supplierName: [{ value: this.account.supplierName, disabled: this.readonly }, Validators.required],
        supplierPhone: [{ value: this.account.supplierPhone, disabled: this.readonly }],
        paidBy: [{ value: this.account.paidBy, disabled: this.readonly }, Validators.required],
        notes: [{ value: this.account.notes, disabled: this.readonly }],
        archivedOn: [{
          value: this.account.archivedOn ? formatDate(this.account.archivedOn, 'y-MM-dd', this._locale) : '',
          disabled: true
        }],
      });

      this.archived = Boolean(this.account.archivedOn);
    }
  }

  async ngOnInit() {
    this.suppliers = await this._accountService.retrieveRecentSuppliers().toPromise().then(res => res.entities);

    if (this.formGroup) {
      const supplierNameInput = this.formGroup.get('supplierName');
      if (supplierNameInput) {
        // supplierNameInput.valueChanges.subscribe(v => console.log(v));
        this.filteredSuppliers$ = supplierNameInput.valueChanges
          .pipe(
            startWith(''),
            map(value => this._getFilteredSuppliers(value))
          );
      }
    }

    this.categories = await this._accountService.retrieveAllCategories().toPromise().then(res => res.entities);
    this.users = await this._accountService.retrieveAllUsers().toPromise().then(res => res.entities);
  }

  optionSelected(event: MatAutocompleteSelectedEvent) {
    const selectedName = event.option.value;
    if (this.formGroup) {
      const categoryInput = this.formGroup.get('category');
      const supplier = ((this.suppliers || []).find(s => s.supplierName === selectedName) || {}).category;
      if (categoryInput) {
        categoryInput.setValue(supplier);
      }
    }
  }

  private _getFilteredSuppliers(value: string): RecentSupplier[] {
    return (this.suppliers || []).filter(s => (s.supplierName || '').startsWith(value || '')).slice(0, 10);
  }

  clear(name: string) {
    if (this.formGroup) {
      const input = this.formGroup.get(name);
      if (input) {
        input.setValue('');
      }
    }
  }
}
